// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(min-width: 1025px)";
var _3 = "(max-width: 1024px)";
var _4 = "(min-width: 1024px)";
var _5 = "screen and (max-width: 600px)";
var _6 = "items-dzUrL";
var _7 = "specialEquipment__icon-5Hvge";
var _8 = "mobileBaggageRules__wrapper-2oubx";
var _9 = "mobileBaggageRules__notification-CcRUl";
var _a = "mobileBaggageRules__notificationText-1H9-U";
var _b = "head-y64_x";
var _c = "passenger_active-1vbTH";
var _d = "passenger-3yQyb";
export { _1 as "__esModule", _2 as "laptop", _3 as "tablet", _4 as "desktop_only", _5 as "mobile", _6 as "items", _7 as "specialEquipment__icon", _8 as "mobileBaggageRules__wrapper", _9 as "mobileBaggageRules__notification", _a as "mobileBaggageRules__notificationText", _b as "head", _c as "passenger_active", _d as "passenger" }
export default { "__esModule": _1, "laptop": _2, "tablet": _3, "desktop_only": _4, "mobile": _5, "items": _6, "specialEquipment__icon": _7, "mobileBaggageRules__wrapper": _8, "mobileBaggageRules__notification": _9, "mobileBaggageRules__notificationText": _a, "head": _b, "passenger_active": _c, "passenger": _d }
